// extracted by mini-css-extract-plugin
export default {"container":"WasteWeights_container__uOHin","title":"WasteWeights_title__eSpxN","selectFirstItem":"WasteWeights_selectFirstItem__B3KV8"};